import './WorkflowPage.scss';

import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[CssConstants]" }] */
import CssConstants from 'style/CssConstants';
import StatefulFooter from 'components/layout/shared/StatefulFooter';
import WorkflowNavBar from 'components/nav/WorkflowNavBar';
import AjaxErrorBoundary from 'components/shared/ErrorBoundary/AjaxErrorBoundary';
import Toaster from '../../../shared/components/Toaster/Toaster';
import Page from '../../../shared/components/Page';

class WorkflowPage extends Page {
  static propTypes = {
    backgroundClassName: PropTypes.string,
    centerNav: PropTypes.object,
    children: PropTypes.node,
    enableDesktopAvatar: PropTypes.bool,
    /* Used to ensure the mobile workflow navbar height and
    style for a specific workflow regardless of screen size.
    /* Ex. Forcing a specific workflow on a tablet whose mobile
    breakpoint is triggered depending on device orientation */
    forceMobileWorkflow: PropTypes.bool,
    leftNav: PropTypes.object,
    rightNav: PropTypes.object,
    showFooter: PropTypes.bool,
    hideNavBar: PropTypes.bool,
  };

  static defaultProps = {
    showFooter: false,
  };

  render() {
    const {
      backgroundClassName,
      centerNav,
      children,
      enableDesktopAvatar,
      forceMobileWorkflow,
      hideNavBar,
      leftNav,
      rightNav,
      showFooter,
    } = this.props;

    const { toasterState } = this.state;
    const rootWrapperClass = toasterState !== 'HIDDEN' ? 'aa-wrapper-blur' : 'aa-wrapper';
    let workflowClassName = showFooter ? 'workflow-page-footer' : 'workflow-page';
    let contentClassName = forceMobileWorkflow ? 'content content-mobile' : 'content';

    if (hideNavBar) {
      contentClassName = 'content-no-padding';
    }

    if (backgroundClassName) {
      workflowClassName += ` ${backgroundClassName}`;
    }

    return (
      <div className="aa-workflow-page">
        <div className={rootWrapperClass}>
          <div className={workflowClassName}>
            {!hideNavBar && (
              <WorkflowNavBar
                leftNav={leftNav}
                rightNav={rightNav}
                centerNav={centerNav}
                enableDesktopAvatar={enableDesktopAvatar}
                forceMobileWorkflow={forceMobileWorkflow}
              />
            )}
            <div className={contentClassName}>
              <AjaxErrorBoundary>
                <div>
                  {children}
                </div>
              </AjaxErrorBoundary>
            </div>
            {showFooter ? <div className="push" /> : null}
          </div>
          {showFooter ? (
            <StatefulFooter backgroundColor={CssConstants.COLOR_AA_BACKGROUND} />
          ) : null}
        </div>
        {this.renderToaster()}
      </div>
    );
  }
}

export default WorkflowPage;
